module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADqSURBVHgB3ZThEYIwDIUfngM4AmzACI7iBnYDcQLZQEZwA44JcAPYADaIybX8EEFToH/87lI4eMlrIAD8FUQUc9w4GrLI8S7XJ7TpSFvPaYeEM0dH81xGWtJotQkDxkcrtSOyLdUcB/ymdxErtcmeF6MsDqfz0RrpQHafIgytGBACskNgxKBFOHoxeCIclRhUCMdDXrKMUwP9+GlpoyhKdrzIB3HF9rzX5E5K2o7mw47sn7Sj9UiNeLInvnGi9Rh8gwUZLSeDBhbm5E8OHzih8CheYAmke1x+O/c0ybAFZKerdEU7d37U5L4AyGLOSyy9aKUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/heart.png
// module id = YfaA
// module chunks = 1